module.exports = __webpack_public_path__ + "img/34_5.6c166732.png";